import { packageNameFromSpec } from '@next-adapter/package-json/package-name-from-spec.js'
import { getAlignedPackageSpec } from './get-aligned-package-spec.js'

export function hasAlignedPackageSpec(spec: string): boolean {
  return getAlignedPackageSpec(packageNameFromSpec(spec)) !== null
}
